// extracted by mini-css-extract-plugin
export default {"section":"_2nt8uO7957","shortcutsList":"_1dmRLwhK58","shortcutsItem":"_6SGUkYCTW2"};